import { P, R } from "apparatus/library/common";
import { createJack } from "apparatus/library/physics/electric/common";
import { Group, Path } from "paper";
/**
 * Common unitilies for drawing plate-mounted components, such as the knifeswitch.
 */
export var Mounted;
(function (Mounted) {
    const PLATE_THICKNESS = 7;
    const PORT_EDGE_OFFSET_X = 20;
    const PORT_EDGE_OFFSET_Y = 11;
    Mounted.appearanceSpecs = [
        { spec: "checkbox", key: "swapSockets", label: "Swap sockets" },
    ];
    Mounted.defaultAppearance = {
        swapSockets: false,
    };
    function renderPlate({ width = 100, height = 40, appearance, offset = P(0, 0) }) {
        const base = new Group([
            // Shade.
            new Path.Rectangle(R(0, 0, width, height + PLATE_THICKNESS), 4.0).withFill("#444444"),
            // Top.
            new Path.Rectangle(R(0, 0, width, height), 4.0).withFill("#666666"),
            // Outline.
            new Path.Rectangle(R(0, 0, width, height + PLATE_THICKNESS), 4.0).withStroke("default"),
        ]);
        const jackPositions = [
            P(PORT_EDGE_OFFSET_X, height - PORT_EDGE_OFFSET_Y),
            P(width - PORT_EDGE_OFFSET_X, height - PORT_EDGE_OFFSET_Y)
        ];
        const swapper = appearance.swapSockets ? 1 : 0;
        const jack1 = createJack("red").withPosition(jackPositions[swapper]);
        const jack2 = createJack("black").withPosition(jackPositions[1 - swapper]);
        const jacks = new Group([jack1, jack2]);
        // Apply offset
        base.position = base.position.add(offset);
        jacks.position = jacks.position.add(offset);
        return {
            base,
            jacks: jacks,
            snaps: jackPositions.map(j => ({ type: "wireport", at: j.add(offset) }))
        };
    }
    Mounted.renderPlate = renderPlate;
})(Mounted || (Mounted = {}));
